import React from "react";
import Common_title from "../common/common-title/Common_title";

const Cancellation_Policy = () => {
  return (
    <section className="Terms_And_Condition bg_img_holder">
      <div className="container">
        <Common_title headingText="Cancellation" spanText="Policy" />

        <div className="policy_holder">
          <div className="text_holder">
            <h3>Cancellation policy</h3>
            <p>
              1.⁠ ⁠Once a payment is successfully processed through the payment
              gateway, the transaction shall be considered final and binding.
            </p>
            <p>
              2.⁠ ⁠Users may request cancellation of a transaction only in the
              following cases:
            </p>

            <ul>
              <li>* Duplicate payment made due to technical error.</li>
              <li>
                * Incorrect amount debited because of payment gateway failure.
              </li>
              <li>
                {" "}
                * Failed transaction where amount is debited but service/payment
                status is unsuccessful.
              </li>
            </ul>
            <p>
              3.⁠ ⁠Cancellation requests must be submitted within 3 working days
              from the date of transaction by contacting customer support
              through registered email or mobile number.
            </p>
            <p>
              4.⁠ ⁠The company reserves the right to verify the transaction
              details before approving any cancellation request.
            </p>
            <p>
              5.⁠ ⁠Subscription plans, convenience fees, gateway charges, or
              taxes paid (if applicable) are non-refundable once the service has
              been activated.
            </p>
            <p>
              6.⁠ ⁠Any misuse, fraudulent activity, or chargeback attempt may
              result in suspension of user account and legal action.
            </p>
          </div>

          <div className="text_holder">
            <h3>Refund Policy</h3>
            <p>
              1.⁠ ⁠Approved refunds shall be processed within 15-20 working days
              to the original payment method.
            </p>
            <p>
              2.⁠ ⁠Refund timelines may vary depending upon the respective bank,
              UPI application, card issuer, or payment gateway provider.
            </p>
            <p>
              3.⁠ ⁠In case of payment gateway failure where the amount is
              deducted but transaction remains pending or failed, the refund
              shall be automatically initiated as per banking/payment gateway
              settlement process.
            </p>
            <p>
              4.⁠ ⁠The platform shall not be responsible for delays caused by
              banks, payment gateway providers, or third-party financial
              institutions.{" "}
            </p>
            <p>
              5.⁠ ⁠Partial refunds, if applicable, shall be processed based on
              the unused portion of the subscribed service or as per mutually
              agreed commercial terms.
            </p>
          </div>

          <div className="text_holder">
            <h3>Non-Refundable Cases</h3>
            <p>Refunds shall not be applicable in the following situations:</p>
            <ul>
              <li>•⁠ ⁠Change of mind after successful payment.</li>
              <li>•⁠ ⁠Incorrect details entered by the user.</li>
              <li>
                •⁠ ⁠Delay caused due to incomplete KYC or verification
                documents.
              </li>
              <li>•⁠ ⁠Violation of platform terms and conditions.</li>
              <li>•⁠ ⁠Service already consumed or utilized.</li>
            </ul>
          </div>

          <div className="text_holder">
            <h3>Contact for Cancellation/Refund</h3>
            <p>
              For cancellation or refund related queries, users may contact:
            </p>
            <p>Email: admin@renteasyapp.in</p>
            <p>Phone: +91-9922054381</p>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Cancellation_Policy;
